import { render, staticRenderFns } from "./PopDepartamento.vue?vue&type=template&id=a7973a46&scoped=true"
import script from "./PopDepartamento.vue?vue&type=script&lang=js"
export * from "./PopDepartamento.vue?vue&type=script&lang=js"
import style0 from "./PopDepartamento.vue?vue&type=style&index=0&id=a7973a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7973a46",
  null
  
)

export default component.exports